"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMAGES = void 0;
const IMAGES = exports.IMAGES = {
  BACKGROUND: require("../img/login-page-background.png"),
  LOGO: require("../img/Acc_Logo_Black_Purple_RGB_resized.png"),
  LOGO_ICON: require("../img/Acc_Mini_Logo_White_resized.png"),
  LOGO_NEW: require("../img/logo-dms-new.png")
};